import React from "react";
const Verify = () => {
  return (
    <div>
      <h1>Verify</h1>
    </div>
  );
};

export default Verify;
